import { useRouter } from 'next/router'
import { useState, VFC } from 'react'
import { Logo, MenuIcon } from 'src/assets/svgs'
import { truewhite, white } from 'src/styles/colors'
import { MYPAGE } from 'src/utils/routes'
import styled from 'styled-components'
import { MemberHeaderContentProps } from '../types'
import { ModalMenu } from './ModalMenu'

export const MemberNarrowHeader: VFC<MemberHeaderContentProps> = ({ user }) => {
  const [isMenuOpen, setMenuOpen] = useState(false)
  const open = () => setMenuOpen(true)
  const close = () => setMenuOpen(false)
  const router = useRouter()

  return (
    <>
      <Header>
        <LogoDiv
          onClick={() => {
            router.push(MYPAGE)
          }}
        >
          <Logo height="22px" width="73px" />
        </LogoDiv>
        <MenuButton onClick={open}>
          <MenuIcon />
        </MenuButton>
      </Header>
      <ModalMenu isOpen={isMenuOpen} user={user} close={close} />
    </>
  )
}

export const NARROW_HEADER_HEIGHT = '45px'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 8px;
  background-color: ${truewhite};
  height: ${NARROW_HEADER_HEIGHT};
`
const LogoDiv = styled.div`
  cursor: pointer;
`
const MenuButton = styled.button`
  width: 45px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  filter: brightness(0.5);
  color: ${white};
  font-size: 13px;
`
